import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { ROUTE_PATHS } from "data/constants";
import Loader from "components/Loader/Loader";
import PrivateRoute from "./PrivateRoute";
import FAQPage from "containers/FAQPage";
import GorgiasForm from "components/GorgiasForm";
import { useAuth } from "hooks/AuthHook";

const SignUpPage = lazy(() => import("containers/SignUpPage"));
const LoginPage = lazy(() => import("containers/LoginPage"));
const ForgotPasswordPage = lazy(() => import("containers/ForgotPasswordPage"));
const ConfirmEmailPage = lazy(() => import("containers/ConfirmEmailPage"));
const ResendConfirmationEmailPage = lazy(() =>
  import("containers/ResendConfirmationEmail")
);
const RecoveryPasswordPage = lazy(() =>
  import("containers/RecoveryPasswordPage")
);
const ConfirmEmailFormPage = lazy(() =>
  import("containers/ConfirmEmailFormPage")
);
const MenuContainerWrapper = lazy(() =>
  import("containers/MenuContainer/MenuContainerWrapper")
);
const CommunityContainerWrapper = lazy(() =>
  import("containers/CommunityContainer/CommunityContainerWrapper")
);
const DocumentPage = lazy(() => import("containers/DocumentPage"));

const RoutesComponent = () => {
  const { authenticatedUser, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path={ROUTE_PATHS.SIGN_UP}
          element={
            <PrivateRoute user={!authenticatedUser}>
              <SignUpPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.LOGIN}
          element={
            <PrivateRoute user={!authenticatedUser}>
              <LoginPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.MOBILE_CONTACT}
          element={<GorgiasForm isOpen={true} />}
        />
        <Route
          path={ROUTE_PATHS.RESEND_CONFIRMATION_EMAIL}
          element={
            <PrivateRoute user={!authenticatedUser}>
              <ResendConfirmationEmailPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.CONFIRM_EMAIL_FORM}
          element={
            <PrivateRoute user={!authenticatedUser}>
              <ConfirmEmailFormPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.FORGOT_PASSWORD}
          element={
            <PrivateRoute user={!authenticatedUser}>
              <ForgotPasswordPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.CONFIRM_EMAIL}
          element={
            <PrivateRoute user={!authenticatedUser}>
              <ConfirmEmailPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATHS.RECOVERY_PASSWORD}
          element={
            <PrivateRoute user={!authenticatedUser}>
              <RecoveryPasswordPage />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTE_PATHS.DASHBOARD}/*`}
          element={
            <PrivateRoute
              user={authenticatedUser}
              redirectPath={ROUTE_PATHS.LOGIN}
            >
              <MenuContainerWrapper />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTE_PATHS.COMMUNITY}/*`}
          element={
            <PrivateRoute
              user={authenticatedUser}
              redirectPath={ROUTE_PATHS.LOGIN}
            >
              <CommunityContainerWrapper />
            </PrivateRoute>
          }
        />
        <Route path={`${ROUTE_PATHS.FAQ}`} element={<FAQPage />} />
        <Route
          path={ROUTE_PATHS.TERMS_AND_CONDITIONS}
          element={<DocumentPage />}
        />
        <Route path={ROUTE_PATHS.PRIVACY_POLICY} element={<DocumentPage />} />
        <Route
          path={"*"}
          element={
            <Navigate
              to={
                !authenticatedUser ? ROUTE_PATHS.LOGIN : ROUTE_PATHS.DASHBOARD
              }
              replace
            />
          }
        />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
